import { WISHLIST_ICON_TYPES_LIST } from "@apps/wishlist/constants/constants";
import { WISHLIST_BRANDING_LAUNCHER_VISIBILITY_TYPES } from "@apps/wishlist/types";
import { boolean, enums, nullable, number, object, string } from "superstruct";

const WishlistsStorefrontValuesBrandingSchema = object({
    wishlistThemeSettings: object({
        primaryColor: string(), // hex
        secondaryColor: string(), // hex
    }),
    wishlistIconSettings: object({
        heartColor: string(), // hex
        backgroundColor: string(), // black | white (hex)
        iconType: enums(WISHLIST_ICON_TYPES_LIST), // default, bookmark, like, heart...
        customIcons: object({
            isEnabled: boolean(),
            outlinedImage: nullable(string()), // link
            filledImage: nullable(string()), // link
        }),
    }),
    wishlistButtonSettings: object({
        color: enums(["primaryColor", "secondaryColor"]), // primary | secondary
        borderRadius: number(), // number
        fontColor: string(), // black | white (hex)
        style: enums(["outlined", "filled"]), // outline | filled
        isCounterEnabled: boolean(),
    }),
    wishlistDrawerAndPageSettings: object({
        drawerPosition: enums(["L", "R"]), // left | right
        launcherBackgroundColor: string(), // black | white (hex)
        launcherFontColor: string(), // black | white (hex)
        launcherIconBackgroundColor: enums(["primaryColor", "secondaryColor"]), // primary | secondary
        buttonsColor: enums(["primaryColor", "secondaryColor"]), // primary | secondary
        buttonsFontColor: string(), // black | white (hex)
        buttonsStyle: enums(["outlined", "filled"]), // outline | filled
        buttonsBorderRadius: number(), // number
        linkColor: enums(["primaryColor", "secondaryColor"]), // primary | secondary
        device: enums([
            WISHLIST_BRANDING_LAUNCHER_VISIBILITY_TYPES.allDevices,
            WISHLIST_BRANDING_LAUNCHER_VISIBILITY_TYPES.desktopOnly,
            WISHLIST_BRANDING_LAUNCHER_VISIBILITY_TYPES.mobileOnly,
            WISHLIST_BRANDING_LAUNCHER_VISIBILITY_TYPES.hide,
        ]),
    }),
});

export default WishlistsStorefrontValuesBrandingSchema;
